import type {
  CancelAppointmentReq,
  LessonDetail,
  LessonPage,
  LessonQuery,
} from '~/features/lessons/model'
import http from '~/utils/http'

export async function getLessons(params: LessonQuery): Promise<LessonPage> {
  return (await http.get<LessonPage>('/admin/lessons', { params })).data
}
export async function getLesson(id: string): Promise<LessonDetail> {
  return (
    await http.get<LessonDetail>(`/admin/lessons/${encodeURIComponent(id)}`)
  ).data
}

export async function cancelAppointment(
  id: string,
  req: CancelAppointmentReq,
): Promise<void> {
  await http.post(`/admin/appointment/${encodeURIComponent(id)}/cancel`, {
    ...req,
    reason: req.reason.trim(),
  })
}
